import ErrorChunkPage from "pages/error/ErrorChunk";
import ErrorDisplayPage from "pages/error/ErrorDisplay";
import React, { Component, ErrorInfo, ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  chunkError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, chunkError: false };
  }

  /**
   * @description 오류 발생 시 호출되는 생명주기 메서드
   */
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary", error, errorInfo);
    if (error.name === "ChunkLoadError") {
      this.setState({ ...this.state, chunkError: true });
    } else {
      this.setState({ ...this.state, hasError: true });
    }
  }

  render() {
    if (this.state.hasError) return <ErrorDisplayPage />;
    if (this.state.chunkError) return <ErrorChunkPage />;
    return this.props.children;
  }
}

export default ErrorBoundary;
